import i18n from '@/utils/i18n';
import React from 'react';
import { SegmentedControl, Typography, YStack } from '@usepepper/sprout-kit-ui';

interface Props<TValue extends string> {
  labelKey: string;
  onChange: (value: TValue) => void;
  options: { labelKey: string; value: TValue }[];
  value: TValue;
}

export const CustomersFilterGroup = <TValue extends string>({
  labelKey,
  onChange,
  options,
  value,
}: Props<TValue>) => {
  const label = i18n.t(labelKey);

  const handleValueChange = (nextValue: string) => {
    const option = options.find((candidate) => candidate.value === nextValue);

    if (option) {
      onChange(option.value);
    }
  };

  return (
    <YStack gap="$4">
      <Typography size="$sm" variant="label">
        {label}
      </Typography>
      <SegmentedControl
        aria-label={label}
        items={options.map((option) => ({
          label: i18n.t(option.labelKey),
          value: option.value,
        }))}
        onValueChange={handleValueChange}
        value={value}
      />
    </YStack>
  );
};
